// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'desktop';

export const Component = () => (
  <path d='M23.037 1H1.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 0 2.485v16.667c0 .43.144.766.431 1.053.288.288.623.432 1.054.432h8.142l-.623 2.92H7.376c-.335 0-.527.192-.527.527 0 .336.192.48.527.48h9.77c.335 0 .527-.144.527-.48 0-.335-.192-.526-.527-.526h-1.628l-.623-2.921h8.142c.431 0 .766-.144 1.054-.432.287-.287.43-.622.43-1.053V2.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 23.037 1Zm-8.525 22.558H10.01l.623-2.921h3.257l.622 2.92Zm9.051-6.85v2.443c0 .335-.191.526-.526.526H1.485c-.335 0-.526-.191-.526-.526v-2.442h22.605Zm0-14.224v13.267H.958V2.484c0-.335.191-.479.526-.479h21.552c.335 0 .526.144.526.48h.001Z' />
);

export const viewBox = '0 0 25 25';
